// src/mocks/handlers/account/businessDetailsHandler.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';
import businessDetailsData from '@/mocks/data/businessDetails.json';
import {
  IBusinessDetailsResponse,
  IRequestBusinessDetails,
} from '@/domains/account/business_details/businessDetails.types';

export const businessDetailsHandler = rest.get<
  IBusinessDetailsResponse,
  IRequestBusinessDetails
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.ACCOUNT_BUSINESS_DETAILS}`,
  (req, res, ctx) => {
    const { customer_uuid } = req.params;

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    const businessDetails = businessDetailsData.find(
      (entry) => entry.uuid === customer_uuid,
    );

    if (!businessDetails) {
      return res(
        ctx.status(404),
        ctx.json({ error: 'Business details not found' }),
      );
    }
    return res(ctx.status(200), ctx.json(businessDetails));
  },
);
